<template>
    <v-select
        v-model="selectedShop"
        label="name"
        placeholder="Search..."
        :options="shops"
        @search="onSearch"
    >
        <template slot="no-options">
            Start typing to search for a shop
        </template>
    </v-select>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            selectedShop: null,
            shops: []
        };
    },

    watch: {
        selectedShop() {
            this.$emit('input', this.selectedShop?.id || null);
        }
    },

    async created() {
        const id = this.value;

        if (!id) {
            return;
        }

        try {
            this.selectedShop = await this.getShop(id);

            this.shops.push(this.selectedShop);
        } catch (error) {
            console.error(error);
        }
    },

    methods: {
        ...mapActions({
            getShops: 'shops/index',
            getShop: 'shops/show'
        }),

        async onSearch(search, loading) {
            if (!search) {
                this.shops = this.selectedShop ? [this.selectedShop] : [];

                return;
            }

            loading(true);

            try {
                const { rows: shops } = await this.getShops({
                    search
                });

                if (
                    this.selectedShop &&
                    shops.every(shop => shop.id !== this.selectedShop.id)
                ) {
                    shops.push(this.selectedShop);
                }

                this.shops = shops;
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }

            loading(false);
        }
    }
};
</script>
